import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  Input,
  ChangeDetectorRef,
  SkipSelf,
  HostBinding,
  Optional,
  AfterViewInit
} from '@angular/core';
import {WithDestroy} from 'src/app/shared/components/with-destroy/with-destroy.mixin';
import { ReplaySubject } from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-truncate-middle',
  templateUrl: './truncate-middle.component.html',
  styleUrls: ['./truncate-middle.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TruncateMiddleComponent extends WithDestroy() implements OnInit, AfterViewInit {
  @Input() minStartingChars = 6;
  @Input() minLastingChars = 6;
  @HostBinding('style.flex-basis') flexBasis = 'auto';
  @ViewChild('projectedContentContainer', {
    read: ElementRef
  })
  projectedContentContainer;

  start = '';
  end = '';
  private contentSubject = new ReplaySubject<string>(1);
  content$ = this.contentSubject.asObservable().pipe(debounceTime(0));
  constructor(private cd: ChangeDetectorRef, @Optional() @SkipSelf() private parentCd: ChangeDetectorRef) {
    super();
  }
  ngAfterViewInit(): void {
    this.contentSubject.next(this.containerContent);
  }

  get containerContent() {
    return this.projectedContentContainer?.nativeElement.innerHTML.trim();
  }

  ngOnInit(): void {
    this.content$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((content) => {
      this.split(content);
      this.flexBasis = this.projectedContentContainer.nativeElement.getBoundingClientRect().width + 'px';
      this.cd.markForCheck();
      this.parentCd?.detectChanges();
    });
  }

  split(text: string) {
    if (text.length > this.minStartingChars + this.minLastingChars) {
      this.start = text.substring(0, text.length - this.minLastingChars);
      this.end = text.substring(text.length - this.minLastingChars);
    } else {
      this.start = text;
      this.end = undefined;
    }
  }

  onContentChange($event) {
    // eslint-disable-next-line no-console
    console.debug('Content mutation', $event);
    this.contentSubject.next(this.containerContent);
  }
}
